// BanToggleButton.jsx
import { useEffect, useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { blockPlayer, unblockPlayer } from 'services/players';

export function BanToggleButton({ userId, initialIsBanned, onBanAction }) {
  const [isBanned, setIsBanned] = useState(initialIsBanned);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setIsBanned(initialIsBanned);
  }, [initialIsBanned]);

  const handleClick = async () => {
    setLoading(true);

    let res;
    if (!initialIsBanned) {
      res = await blockPlayer(userId);
    } else {
      res = await unblockPlayer(userId);
    }
    if (res.status === 200 || res.status === 201) {
      setIsBanned(!isBanned);
      setLoading(false);
      onBanAction();
      console.log(`Player ${userId} has been ${isBanned ? 'unbanned' : 'banned'}.`);
    } else {
      alert(res?.data?.message || 'Failed to change ban status');
      setLoading(false);
    }
  };

  return (
    <Button
      size='small'
      variant='outlined'
      color={isBanned ? 'error' : 'success'}
      disabled={loading}
      onClick={handleClick}
      style={{ borderColor: isBanned ? '#f44336' : '#4caf50', color: isBanned ? '#f44336' : '#4caf50' }}
      sx={{
        borderWidth: 2,
        '&:hover': { borderWidth: 2 }
      }}
    >
      {loading ? <CircularProgress size={16} /> : isBanned ? 'Unban' : 'Ban'}
    </Button>
  );
}
